import { Controller } from "react-hook-form";
import React from "react";
import DatePicker from "react-datepicker";
import * as PropTypes from "prop-types";
import { SelectInput } from "../inputs/selectInput.jsx";
import { CodeInput } from "../inputs/codeInput.jsx";
import { TextInput } from "../inputs/textInput.jsx";
import { useSelector } from "react-redux";
import { TextareaInput } from "../inputs/textareaInput.jsx";
import { useMobileDetector } from "../../hooks/useMobileDetector.js";

SelectInput.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.func,
};

export function SimpleField({
  name,
  type,
  label,
  code,
  afterLabel,
  control,
  select,
  disabled,
  wrapperClasses,
  fieldClasses,
  placeholder,
}) {
  let session = useSelector((state) => state.session);
  let isMobile = useMobileDetector();
  let formats = session.user
    ? [
        session.account.dateFormat,
        session.account.dateFormat.replaceAll("-", "/"),
        session.account.dateFormat.replace("yyyy-", "").replace("-yyyy", ""),
        session.account.dateFormat
          .replace("yyyy-", "")
          .replace("-yyyy", "")
          .replaceAll("-", "/"),
      ]
    : [];

  return (
    <div className={`flex flex-col gap-2 ${wrapperClasses || ""}`}>
      {label && (
        <label className={"font-medium flex gap-2"} htmlFor={name}>
          <span>{label}</span>
          {afterLabel}
        </label>
      )}
      <Controller
        render={({ field: { value, onChange }, fieldState, formState }) => {
          return (
            <>
              {(!type ||
                (type == "date" && isMobile()) ||
                type == "text" ||
                type == "file" ||
                type == "email" ||
                type == "password") && (
                <TextInput
                  value={
                    type == "date" && value
                      ? new Date(value).toISOString().split("T")[0]
                      : value
                  }
                  type={type}
                  placeholder={placeholder}
                  onChange={onChange}
                  disabled={disabled}
                  fieldClasses={fieldClasses}
                />
              )}
              {type == "number" && (
                <input
                  type={"text"}
                  placeholder={placeholder}
                  disabled={disabled}
                  step={0.01}
                  name={name}
                  className={`p-3 border border-gray-400 outline-none focus:border-gray-800 rounded w-full ${
                    disabled && "bg-gray-200"
                  } ${fieldClasses || ""}`}
                  value={value?.toString()}
                  lang={"en_EN"}
                  onChange={(e) => {
                    let float = e.target.value.replace(",", ".");
                    if (!float.endsWith(".") && !isNaN(parseFloat(float)))
                      onChange(parseFloat(float));
                    else onChange(e.target.value);
                  }}
                />
              )}
              {type == "date" && !isMobile() && (
                <>
                  <DatePicker
                    className={`p-3 border border-gray-400 rounded outline-none focus:border-gray-800 ${
                      fieldClasses || ""
                    }`}
                    selected={value ? new Date(value) : null}
                    strictParsing
                    onChange={(e) => onChange(e.toISOString().split("T")[0])}
                    dateFormat={formats}
                  />
                </>
              )}
              {type == "textarea" && (
                <TextareaInput
                  value={value}
                  onChange={onChange}
                  disabled={disabled}
                  fieldClasses={fieldClasses}
                />
              )}
              {type == "select" && (
                <SelectInput
                  select={select}
                  onChange={onChange}
                  value={value}
                />
              )}
              {type == "code" && (
                <CodeInput code={code} onChange={onChange} value={value} />
              )}

              {fieldState?.error?.message && (
                <div className={"text text-red-400"}>
                  {fieldState?.error?.message}
                </div>
              )}
            </>
          );
        }}
        control={control}
        name={name}
      />
    </div>
  );
}
